/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Plugin_Cap_SaveInputs */



/**
* | output |
* | --- |
* | "Save limit" |
*
* @param {Agent_Plugin_Cap_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const agent_plugin_cap_save = /** @type {((inputs?: Agent_Plugin_Cap_SaveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Plugin_Cap_SaveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Limite d'épargne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sparlimit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Limite di salvataggio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохраните лимит")
	if (locale === "es") return /** @type {LocalizedString} */ ("Límite de ahorro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("储蓄限额")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存制限")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बचत सीमा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar limite")
	return /** @type {LocalizedString} */ ("Save limit")
});